// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_settings_model from "./web_settings_model.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Option from "melange/option.js";

function disabled(p) {
  if (p.loading) {
    return true;
  } else {
    return p.pending;
  }
}

function input(send, f) {
  return function (param) {
    return Lui_elements.on_input(send, (function (value) {
      return {
        TAG: /* Settings */ 37,
        _0: Curry._1(f, value)
      };
    }), param);
  };
}

function controls(model, source, send) {
  const partial_arg = "Sandbox provider";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___001_) {
      const partial_arg = {
        TAG: /* Settings */ 37,
        _0: {
          TAG: /* Change */ 1,
          _0: {
            TAG: /* Sandbox_provider */ 1,
            _0: "boat"
          }
        }
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (p) {
        if (p.provider === "boat") {
          return true;
        } else {
          return disabled(p);
        }
      }), source)));
      const partial_arg$3 = "outline";
      const partial_arg$4 = "Boat";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___002_) {
        const partial_arg = {
          TAG: /* Settings */ 37,
          _0: {
            TAG: /* Change */ 1,
            _0: {
              TAG: /* Sandbox_provider */ 1,
              _0: "instabox"
            }
          }
        };
        const partial_arg$1 = (function (param) {
          return Lui_elements.press(send, partial_arg, param);
        });
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
          if (p.provider === "instabox") {
            return true;
          } else {
            return disabled(p);
          }
        }), source)));
        const partial_arg$3 = "outline";
        const partial_arg$4 = "Instabox";
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$1 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$2 = 8;
  const partial_arg$3 = "Instabox API key (ibk_...). Entered once, verified, and stored encrypted. It is never shown again.";
  const partial_arg$4 = "muted";
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___003_) {
        const partial_arg = input(send, (function (v) {
          return {
            TAG: /* Change */ 1,
            _0: {
              TAG: /* Instabox_token */ 2,
              _0: v
            }
          };
        }));
        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map(disabled, source)));
        const partial_arg$2 = "Instabox API key";
        const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (p) {
          return p.token;
        }), source)));
        return function (param, param$1) {
          return Lui_elements.secure_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___004_) {
          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (p) {
            const i = p.instabox;
            if (i !== undefined) {
              return "Instabox connected (" + (i.hint + ("). Machines: " + (String(i.machines) + (" of " + (String(i.max_machines) + (" total, " + (String(i.running) + " running.")))))));
            } else {
              return "No Instabox credential saved yet.";
            }
          }), source)));
          return function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$5 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$6 = 8;
  const partial_arg$7 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, param, param$1);
  };
  const partial_arg$8 = Signal.map((function (p) {
    return p.provider === "instabox";
  }), source);
  const partial_arg$9 = "Maximum concurrent sessions";
  const partial_arg_0$2 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$2 = {
    hd: (function (param, param$1) {
      return Lui_elements.row(undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$8, partial_arg$7, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___005_) {
              const partial_arg = input(send, (function (value) {
                return {
                  TAG: /* Change */ 1,
                  _0: {
                    TAG: /* Session_limit */ 0,
                    _0: value
                  }
                };
              }));
              const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map(disabled, source)));
              const partial_arg$2 = "Maximum concurrent sessions";
              const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (p) {
                return p.value;
              }), source)));
              return function (param, param$1) {
                return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.scoped((function (__lui_context___006_) {
                const partial_arg = {
                  TAG: /* Settings */ 37,
                  _0: /* Submit */ 2
                };
                const partial_arg$1 = (function (param) {
                  return Lui_elements.press(send, partial_arg, param);
                });
                const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (p) {
                  return !Mapre_web__Web_settings_model.can_save(p);
                }), source)));
                const partial_arg$3 = "primary";
                const partial_arg$4 = "Save settings";
                return function (param, param$1) {
                  return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param, param$1);
            }),
            tl: /* [] */ 0
          }
        }
      }
    }
  };
  const partial_arg$10 = {
    hd: partial_arg_0$2,
    tl: partial_arg_1$2
  };
  const partial_arg$11 = 8;
  const partial_arg$12 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, param, param$1);
  };
  const partial_arg$13 = Signal.map(Mapre_web__Web_model.can_manage_project, model);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$13, partial_arg$12, param, param$1);
  };
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return Stdlib__Option.value(m.settings_form, Mapre_web__Web_settings_model.initial(""));
  }), model);
  const partial_arg = "App settings";
  const partial_arg$1 = 2;
  const partial_arg$2 = "Settings apply to this workspace. Owners and Admins can set 1 to 10 concurrent sessions. The default is 5. Environment builds also use a slot. Lowering the limit keeps running sessions active.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = Signal.map((function (p) {
    return p.message !== "";
  }), source);
  const partial_arg$5 = {
    TAG: /* Settings */ 37,
    _0: /* Close */ 0
  };
  const partial_arg$6 = (function (param) {
    return Lui_elements.press(send, partial_arg$5, param);
  });
  const partial_arg$7 = "ghost";
  const partial_arg$8 = "Close settings";
  const partial_arg$9 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$10 = Signal.map((function (m) {
    return !m.compact;
  }), model);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___010_) {
      const partial_arg = {
        TAG: /* Settings */ 37,
        _0: /* Refresh */ 1
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___010_.ui_scope, Signal.map(disabled, source)));
      const partial_arg$3 = "outline";
      const partial_arg$4 = "Refresh settings";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$10, partial_arg$9, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$11 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$12 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___007_) {
        const partial_arg = {
          TAG: /* Personal_tokens */ 40,
          _0: {
            TAG: /* Open */ 0,
            _0: ""
          }
        };
        const partial_arg$1 = (function (param) {
          return Lui_elements.press(send, partial_arg, param);
        });
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (m) {
          if (m.current_user === undefined) {
            return true;
          } else {
            return Mapre_web__Web_types.workspace(m.route) === undefined;
          }
        }), model)));
        const partial_arg$3 = "outline";
        const partial_arg$4 = "Personal access tokens";
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___008_) {
            const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (p) {
              if (p.loading) {
                return "Loading settings...";
              } else {
                return "Maximum concurrent sessions: " + p.value;
              }
            }), source)));
            return function (param, param$1) {
              return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }),
        tl: {
          hd: controls(model, source, send),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$4, (function (param, param$1) {
                return Lui_elements.scoped((function (__lui_context___009_) {
                  const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map((function (p) {
                    return p.message;
                  }), source)));
                  const partial_arg$1 = "notice";
                  return function (param, param$1) {
                    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param, param$1);
              }), param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.row(undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, param, param$1);
              }),
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  };
  const partial_arg$13 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$14 = "form-card";
  const partial_arg$15 = 0;
  const partial_arg$16 = 16;
  const partial_arg$17 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, partial_arg$16, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
